import { REDUCER_NAME } from './constants';

export const getState = state => state.app[REDUCER_NAME];

const getDataState = state => getState(state)[REDUCER_NAME];

export const getData = state => getDataState(state).data;

export const getIsFetching = state => getDataState(state).isFetching;
